<template>
  <div>
    <div class="row">
      <div class="input-field col s12 m6">
        <i class="fas fa-dollar-sign prefix grey-text"></i>
        <input
          name="amount"
          id="amount"
          @input="updateAmounts"
          autofocus
          v-model="amount"
          step="0.01"
          type="text"
          inputmode="decimal"
          v-validate="'min_value:0.01|required'"
          class="inputText"
          lang="en-001">
        <label for="amount">Amount</label>
        <span class="red-text" v-show="errors.has('amount')">{{ errors.first('amount') }}</span>
      </div>
    </div>

    <div class="row">
      <div class="input-field col s12 m6">
        <i class="fas fa-file-invoice prefix grey-text"></i>
        <input v-model="invoice" id="invoice" type="text" class="validate">
        <label for="invoice">{{ invoiceLabel }}</label>
      </div>
      <div class="input-field col s12 m6">
        <i class="fas fa-sticky-note prefix grey-text"></i>
        <input v-model="note" id="note" type="text" class="validate">
        <label for="note">Note</label>
      </div>
    </div>

    <div class="row">
      <custom-fields v-model="customFields" flow="ach">
        <template #default="{ definitions, values, onInput }">
          <div class="input-field col s12 m6"
               v-for="(d, idx) in definitions"
               :key="'cf-' + d.label">
            <i class="fas fa-tag prefix grey-text"></i>
            <input
              :id="'custom-field-' + idx"
              type="text"
              :maxlength="d.type === 'numerical' ? 15 : 255"
              :inputmode="d.type === 'numerical' ? 'decimal' : 'text'"
              :pattern="d.type === 'numerical' ? '\\d+(\\.\\d+)?' : null"
              :required="d.required"
              :value="values[idx]"
              @input="onInput($event.target.value, idx, d)">
            <label :for="'custom-field-' + idx">
              {{ d.label }}<span v-if="d.required"> (required)</span>
            </label>
          </div>
        </template>
      </custom-fields>
    </div>

    <center v-if="showTips">
      <section class="mt-10">
        <tips :qid="qid" :tips-updated="tipsUpdated"></tips>
      </section>
    </center>

    <button
      class="btn-large wide-btn mt-10"
      type="submit"
      name="action"
      @click="submit"
      :disabled="!submittable"
      v-if="!processing">
      Charge {{ grossAmount | currency }}
    </button>

    <div v-else class="grey-text center mt-10">
      <i class="fas fa-spinner fa-spin grey-text"></i>
      Processing...
    </div>

    <div class="center grey-text mt-5" v-if="feeAmount > 0">
      Gross amount: <b>{{ grossAmount | currency }}</b> |
      Processing fee: <b>{{ feeAmount | currency }}</b>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import tips from '../../tips'
import customFields from '../custom_fields/custom_fields'

export default {
  components: { tips, customFields },
  props: ['qid', 'gid', 'showTips', 'requireInvoiceField'],
  data() {
    return {
      amount: null,
      note: null,
      invoice: '',
      grossAmount: 0,
      feeAmount: 0,
      lastGrossCalcRequestId: 0,
      processing: false,
      selectedTip: 0,
      tipCustomAmount: 0,
      customFields: []
    }
  },
  methods: {
    updateAmounts() {
      this.lastGrossCalcRequestId++
      let requestId = this.lastGrossCalcRequestId
      this.$apollo.query({
        query: gql`query ($amount: Float!, $tipPercent: Int, $tipCustomAmount: Float) {
          merchant {
            grossAchAmountCalc(amount: $amount, tipPercent: $tipPercent, tipCustomAmount: $tipCustomAmount) {
              grossAmount
              tip
              amountWithTip
              fee
            }
          }
        }`,
        variables: {
          amount: parseFloat(this.amount) || 0,
          tipPercent: parseInt(this.selectedTip),
          tipCustomAmount: parseFloat(this.tipCustomAmount)
        }
      }).then(response => {
        if (requestId === this.lastGrossCalcRequestId) {
          this.grossAmount = response.data.merchant.grossAchAmountCalc.grossAmount
          this.feeAmount = response.data.merchant.grossAchAmountCalc.fee
        }
      }).catch(error => {
        console.error('Error calculating amounts:', error)
      })
    },
    tipsUpdated(selectedTip, tipCustomAmount) {
      this.selectedTip = selectedTip
      this.tipCustomAmount = tipCustomAmount
      this.updateAmounts()
    },
    submit() {
      this.processing = true
      this.$apollo.mutate({
        mutation: gql`
          mutation($id: ID!, $amount: Float!, $tipAmount: Float, $tipPercent: Int, $note: String, $invoice: String, $customFields: [CustomFieldValueInput!]) {
            achRepeatSale(input: {amount: $amount, sourceTransactionId: $id, tipPercent: $tipPercent, tipAmount: $tipAmount, note: $note, invoice: $invoice, customFields: $customFields}) {
              transaction { deprecatedId }
              errors
            }
          }
        `,
        variables: {
          amount: parseFloat(this.amount),
          id: this.gid,
          note: this.note,
          invoice: this.invoice,
          tipPercent: parseInt(this.selectedTip),
          tipAmount: parseFloat(this.tipCustomAmount),
          customFields: this.customFields
        }
      }).then(response => {
        if (response.data.achRepeatSale.errors.length > 0) {
          this.processing = false
          this.notifyError(response.data.achRepeatSale.errors[0])
        } else {
          window.location.href = '/client/ach_transactions/' + response.data.achRepeatSale.transaction.deprecatedId
        }
      }).catch(error => {
        this.processing = false
        console.error('Error submitting transaction:', error)
        this.gqlErrorHandler(error)
      })
    }
  },
  computed: {
    invoiceLabel() {
      return this.requireInvoiceField ? 'Invoice # (required)' : 'Invoice # (optional)'
    },
    submittable() {
      if (this.requireInvoiceField && (!this.invoice || this.invoice.trim() === '')) {
        return false
      }
      return this.amount != null && this.amount > 0
    }
  }
}
</script>
